import { LearningStats, LearningStatsAPI, RewardsStats } from '../types/profile-card.types'

export function formatLearningStats(learningStats: LearningStatsAPI | undefined): LearningStats {
  if (!learningStats) {
    return {
      activitiesDone: 0,
      activityAccuracy: 0,
      bestActivityAccuracy: 0,
      totalTimeSpent: 0,
      watchedVideoDuration: 0,
    }
  }

  const activitiesDone = learningStats.activities.correctAnswers + learningStats.activities.wrongAnswers
  const activityAccuracy = Math.floor((learningStats.activities.correctAnswers / activitiesDone) * 100)
  const bestActivityAccuracy = Math.floor(learningStats.activities.bestActivityAccuracy * 100)

  return {
    activitiesDone,
    activityAccuracy,
    bestActivityAccuracy,
    totalTimeSpent: learningStats.timeSpent || 0,
    watchedVideoDuration: learningStats.watchedVideoDuration || 0,
  }
}

export function formatRewardsStats(rewardsStats: RewardsStats | undefined): RewardsStats {
  if (!rewardsStats) {
    return {
      chest: { opened: 0, total: 0 },
      gems: 0,
      kudos: 0,
      xp: 0,
    }
  }

  return rewardsStats
}
